import { render, staticRenderFns } from "./select-product.vue?vue&type=template&id=520f43b0&scoped=true&"
import script from "./select-product.vue?vue&type=script&lang=js&"
export * from "./select-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f43b0",
  null
  
)

export default component.exports